import { Box, Text, Flex, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { motion } from "framer-motion";

// StepCard Component
const StepCard = ({
    number,
    title,
    description,
    highlight,
    isLeftAligned,
    imagePath,
    mobileImagePath
}: {
    number: number;
    title: string;
    description: string;
    highlight: string;
    isLeftAligned: boolean;
    imagePath: string;
    mobileImagePath: string;
}) => {
    const MotionFlex = motion(Flex);
    const MotionBox = motion(Box);

    const currentImagePath = useBreakpointValue({ base: mobileImagePath, md: imagePath });

    const bg = useColorModeValue('red.500', 'red.200');
    const color = useColorModeValue('#FFFFF', 'white');

    const isMobile = useBreakpointValue({ base: true, md: false });

    const imageAlignment = isMobile && (number === 2 || number === 4) ? "flex-end" : isLeftAligned ? "flex-start" : "flex-end";
    const gapBetweenImageAndText = isMobile && (number === 2 || number === 4) ? "20px" : "0px";  

    return (
        <MotionFlex
            direction={isLeftAligned ? "row" : "row-reverse"}
            align="center"
            justify="center"
            w="full"
            position="relative"
            mb={{ base: 8, md: 16 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            textAlign="left"
        >
            {/* Adjusted Box for Images */}
            <Box
                as="span"
                mb={{ base: 4, md: 0 }}
                w={{ base: "80%", md: "auto" }}
                display="flex"
                justifyContent={imageAlignment} 
                ml={{ base: "auto", md: 0 }}  
                mr={{ base: "auto", md: 0 }}  
            >
                <img
                    src={currentImagePath}
                    alt={`Step ${number}`}
                    style={{
                        width: "70%",
                        height: "auto",
                    }}
                />
            </Box>

            {/* Adjusted Box for Text */}
            <MotionBox
                color={color}
                border="1px solid red"  
                p={{ base: 4, md: 6 }}
                ml={{ base: 0, md: isLeftAligned ? 4 : 0 }}
                mr={{ base: 0, md: isLeftAligned ? 0 : 4 }}
                borderRadius="20px"
                w={{ base: "100%", md: "50%" }}
                h={{ base: "auto", md: "auto" }}
                textAlign={{ base: "center", md: "left" }}
                mt={{ base: gapBetweenImageAndText, md: 0 }}  
            >
                <Text
                    fontSize={{ base: "14px", md: "28px" }}
                    fontWeight="600"
                    lineHeight={{ base: "20px", md: "36px" }}
                    mb={2}
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                >
                    {title}{" "}
                    <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">
                        {highlight}
                    </Text>
                </Text>
                <Text
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: "12px", md: "18px" }}
                    lineHeight={{ base: "16px", md: "28px" }}
                    fontWeight="400"
                    textAlign="justify"
                >
                    {description}
                </Text>
            </MotionBox>
        </MotionFlex>
    );
};

export default StepCard;
